export const ProductShareTypes = Object.freeze({
  NOSHARE: 0,
  SHARE: 1,
  VIRTUALROSTER: 2
});

export const AvailabilityTypes = Object.freeze({
  FIXED_LIMIT: 0,
  UNLIMITED: 1,
  LIMITED_BY_RESOURCES: 2
});



//////////////////
// WEBPACK FOOTER
// ./src/enums/productAvailabilityTypes
// module id = 410
// module chunks = 0